<template>
    <header>
        <nav>
            <section class="brand_section">
                <div class="brand_wapper">
                    <router-link to="/">
                        <img src="../../assets/logo-social-sniffer-horizontal.svg" />
                    </router-link>
                </div>
                <div>
                    <select-2 
                        v-model="selectedWorkspace"
                        :options="registeredWorkspaces"
                        :settings="
                            { 
                                width: '200px', 
                                minimumResultsForSearch: 0
                            }
                        "
                        @input="selectedWorkspaceChange"
                    ></select-2>
                </div>
            </section>
            <section>
                <ul>
                    <li @click="toggleLanguageList" class="language_list_parent_node">
                        <span class="icon material-icons nav_action">
                            language
                        </span>
                        <div v-if="showLanguageList" class="toggle_list language_list">
                            <ul>
                                <language-list-item v-for="langItem in languageList" 
                                    :key="langItem.id" 
                                    :lang-id="langItem.id" 
                                    :lang-code="langItem.langCode" 
                                    @change-lang="changeLang"
                                >
                                </language-list-item>
                            </ul>
                        </div>
                    </li>
                    <li @click="toggleAlarmList" class="alarm_list_parent_node">
                        <span class="icon material-icons nav_action">
                            notifications
                        </span>
                        <div v-if="showAlarmList" class="toggle_list alarm_list">
                            <div v-if="alarmSummary.length == 0" class="empty_notification_list">
                                <span class="icon material-icons empty_notification_icon">notifications_off</span>
                                <span>Yeni Alarm Bildiriminiz Bulunmamaktadır</span>
                            </div>
                            <ul v-else>
                                <alarm-summary-item v-for="alarmItem in alarmSummary" 
                                    :key="alarmItem.id"
                                    :icon-name="alarmItem.iconName"
                                    :alarm-title="alarmItem.title">
                                </alarm-summary-item>
                                <li class="divider">
                                    <hr>
                                </li>
                                <li @click="forwardToAlarmPage()" class="show_all_alarms">
                                    <span>Tümünü göster</span>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li @click="toggleUserList" class="user_list_parent_node">
                        <div class="user_icon_wrapper">
                            <font-awesome-icon :icon="['fas', 'user']" class="nav_action user_icon" />
                        </div>
                        <div v-show="showUserList" class="toggle_list user_list">
                            <ul>
                                <li v-if="!isDomainUser" @click="openSettingsDialog">{{ $t("navBar.settings") }}</li>
                                <li @click="logout">{{ $t("navBar.logout") }}</li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </section>
        </nav>
    </header>
</template>

<script>
import AlarmSummaryItem from "../alarm/AlarmSummaryItem.vue";
import LanguageListItem from "../language/LanguageListItem.vue";

export default {
    components: {
        AlarmSummaryItem,
        LanguageListItem
    },
    inject: ["isGrantedPermission"],
    emits: ["openSettingsDialog"],
    data() {
        return {
            showUserList: false,
            showAlarmList: false,
            alarmSummaryList: {},
            showLanguageList: false,
        }
    },
    computed: {
        alarmSummary() {
            return this.$store.getters["alarm/alarmSummary"];
        },
        languageList() {
            return this.$store.getters["language/languageList"];
        },
        registeredWorkspaces(){
            return this.$store.getters.registeredWorkspcesForSelect;  
        },
        isDomainUser() {
            return this.$store.getters.isDomainUser;
        },
        selectedWorkspace: {
            get() {
                return this.$store.getters.workspaceIdForHeader;
            },
            set(val) {
                this.selectedWorkspaceChange(val);
            }
        }
    },
    methods: {
        toggleLanguageList() {
            if (this.showAlarmList) {
                this.showAlarmList = false;
            }

            if (this.showUserList) {
                this.showUserList = false;
            }

            this.showLanguageList = !this.showLanguageList;
        },
        toggleAlarmList() {
            if (this.showLanguageList) {
                this.showLanguageList = false;
            }

            if (this.showUserList) {
                this.showUserList = false;
            }

            this.showAlarmList = !this.showAlarmList;
        },
        toggleUserList() {
            if (this.showLanguageList) {
                this.showLanguageList = false;
            }

            if (this.showAlarmList) {
                this.showAlarmList = false;
            }

            this.showUserList = !this.showUserList;
        },
        logout() {
            this.$store.dispatch("logout");
            this.$router.replace("/login");
        },
        openSettingsDialog() {
            this.$emit("openSettingsDialog");
        },
        changeLang(langId) {
            this.$store.dispatch("putLanguage", { langId: langId });
        },
        clickOutside(event) {
            const langContainer = document.querySelector(".language_list_parent_node");
            const alarmContainer = document.querySelector(".alarm_list_parent_node");
            const userContainer = document.querySelector(".user_list_parent_node");
            
            if (langContainer && !langContainer.contains(event.target.parentNode)) {
                this.showLanguageList = false;
            }

            if (alarmContainer && !alarmContainer.contains(event.target.parentNode)) {
                this.showAlarmList = false;
            }

            if (userContainer && !userContainer.contains(event.target.parentNode)) {
                this.showUserList = false;
            }
        },
        async selectedWorkspaceChange(id) {
            await this.$store.dispatch("fetchClientContext", { workspaceId: id });

            this.$router.replace("/home");
        },
        forwardToAlarmPage() {
            if (this.isGrantedPermission("AlarmAdmin")) {
                this.$router.replace("/alarms?zone=admin");
            } else if (this.isGrantedPermission("AlarmIndividual")) {
                this.$router.replace("/alarms?zone=individual");
            } else {
                this.$router.replace("/unauthorized");
            }            
        }
    },
    mounted() {
        document.addEventListener("click", this.clickOutside);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.clickOutside);
    }
}
</script>

<style scoped>
header {
    width: 100%;
    height: 4.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    border-bottom: 2.5px solid var(--sniffer-color-border);
    position: fixed;
    margin: 0;
    z-index: 10;
}

header div {
    display: inline-block;
}

header nav {
    width: 96%;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

header ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

header li {
    margin: 0 3px;
    user-select: none;
}

.nav_action {
    font-size: 36px;
    color: var(--sniffer-color-icon-small);
    cursor: pointer;
}

.user_icon_wrapper {
    padding: 7px 10.75px;
    height: 42px;
    width: 42px;
    border-radius: 50%;
    background-color: var(--sniffer-color-secondary);
}

.user_icon {
    font-size: 24px !important;
}

header span:active,
.user_icon:active {
    color: var(--sniffer-color-primary);
}

.brand_section {
    width: 35%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.brand_wapper {
    margin-right: 36px;
}

.brand_wapper img {
    cursor: pointer;
}

.toggle_list ul {
    top: 54px;
    display: flex;
    position: fixed;
    flex-direction: column;
    justify-content: space-evenly;
    border: 1px solid var(--sniffer-color-dark-grey);
    background-color: var(--sniffer-color-light-grey);
}

.toggle_list ul li {
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
}

.empty_notification_list {
    top: 54px;
    right: 90px;
    width: 210px;
    height: 90px;
    display: flex;
    position: fixed;
    text-align: center;
    align-items: center;
    flex-direction: column;
    justify-content: space-evenly;
    color: var(--sniffer-color-icon-small);
    background-color: var(--sniffer-color-light-grey);
    border: 1px solid var(--sniffer-color-dark-grey);
}

.language_list ul {
    align-items: center;
    right: 132px;
    min-width: 108px;
    min-height: 480px;
}

.alarm_list ul {
    right: 94px;
    min-width: 270px;
    min-height: 204px;
    max-height: 540px;
}

.user_list ul {
    right: 42px;
    min-width: 102px;
    min-height: 42px;
    top: 60px !important;
}

.alarm_list ul li {
    padding: 0 12px;
    justify-content: space-between;
    height: 42px;
}

.alarm_list ul li:hover,
.user_list ul li:hover {
    background-color: var(--sniffer-color-border);
}

.user_list ul li {
    height: 30px;
    justify-content: space-around;
}

.divider {
    height: 0 !important;
    cursor: default !important;
}

.divider:hover {
    background-color: transparent !important;
}

.divider hr {
    width: 100%;
}

.show_all_alarms {
    justify-content: end !important;
}

@media (max-width: 1281px) {
    .language_list ul {
        right: 120px;
    }

    .alarm_list ul {
        right: 82px;
    }
}
</style>